import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ravago-digital-platform/ravago-digital-platform/apps/next-page-consumer/app/lib/components/base/page-not-found/page-not-found.tsx");
